import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import DefaultButton from '../../../components/Accessibility/DefaultButton';
import DefaultText from '../../../components/Accessibility/DefaultText';
import PageTitle from '../../../components/Accessibility/PageTitle';
import VoltarButton from '../../../components/Accessibility/VoltarButton';
import LoadingApp from '../../../components/LoadingApp';
import ModalFeedBack from '../../../components/ModalFeedBack';
import { Psicoterapeuta } from '../../../interfaces/entities/UnimedAcolhe/Psicoterapeuta';
import { getTrocaDeProfissionalPsicoterapeuta } from '../../../services/SaudeBemEstar/UnimeAcolheService';
import PsicoterapeutaCard from './PsicoterapeutaCard';
import './styles.css';

const MeuPsicoterapeuta: React.FC = () => {

  const navigate = useNavigate();
  const [loading, setLoading] = useState<boolean>(false);
  const [psicoterapeuta, setPsicoterapeuta] = useState<Psicoterapeuta>();
  const [modalFeedback, setModalFeedback] = useState<null | {
    icon?: 'error' | 'success' | 'warning', title?: string, textButton?: string, subTitle?: string,
    closeAction: () => void, showButtonModal: boolean, buttonAction?: () => void
  }>(null);

  const fetchPsicoterapeuta = async () => {
    setLoading(true);
    const response = await getTrocaDeProfissionalPsicoterapeuta();
    if (response?.status === 200) {
      setPsicoterapeuta(response?.data);
    } else {
      handleError(response?.data?.mensagem);
    }
    setLoading(false);
  }

  const handleError = (errorMessage: string) => {
    openModal('warning', 'Atenção', errorMessage, 'Voltar',
      () => navigate('/saudeBemEstar/unimedAcolhe/inicio'), () => navigate('/saudeBemEstar/unimedAcolhe/inicio')
    );
  }

  useEffect(() => {
    fetchPsicoterapeuta();
  }, []);

  const openModal = (
    icon: 'error' | 'success' | 'warning', title: string, subtitle: string, textButton: string, closeAction: () => void, buttonAction: () => void
  ) => {
    setModalFeedback({
      icon: icon,
      title: title,
      subTitle: subtitle,
      textButton: textButton,
      showButtonModal: true,
      closeAction: closeAction,
      buttonAction: buttonAction
    });
  }

  return (
    <>
      <LoadingApp showLoading={loading} />
      <div className='feature-container'>
        <PageTitle text='Meu psicoterapeuta' />
        {!!psicoterapeuta?.descricao && !!psicoterapeuta.nomeBeneficiario ?
          <>
            <DefaultText text='Confira aqui informações sobre o profisional que está te acompanhando.' maxWidth={'600px'} />
            <DefaultText text='Para solicitar a troca do profissional, é necessário que indique por qual motivo deseja realizar a troca.' maxWidth={'600px'} />
            <PsicoterapeutaCard psicoterapeuta={psicoterapeuta} />
            <DefaultText text='<b>E lembre-se:</b> a troca pode ser realizada uma única vez e até a quarta sessão.' maxWidth={'600px'} />
            <DefaultText text='Para mais informações, consulte o Manual de Atendimento.' maxWidth={'600px'} />
            <div className='buttons-holder'>
              <DefaultButton text='Solicitar troca'
                onClick={() => navigate('/saudeBemEstar/unimedAcolhe/meuPsicoterapeuta/solicitarTroca')}
                disabled={!psicoterapeuta?.solicitar}
                aria-label={`solicitar troca de ${psicoterapeuta.nomeBeneficiario} como psicoterapeuta`}
              />
              <DefaultButton text='Manual de atendimento' variant='outlined' onClick={() => navigate('/saudeBemEstar/unimedAcolhe/manualDeAtendimento')} />
            </div>
          </>
          :
          <>
            <DefaultText text='Você ainda não possui psicoterapeuta selecionado. Agende sua consulta para selecionar.' maxWidth={'600px'} />
            <DefaultButton text='Agendar consulta' disabled={!psicoterapeuta?.solicitar} onClick={() => navigate('/saudeBemEstar/unimedAcolhe/agendamentos')} />
          </>
        }
        <VoltarButton onClick={() => window.history.back()} />

      </div>
      <ModalFeedBack
        showModal={!!modalFeedback}
        handleShowModal={modalFeedback?.closeAction}
        title={modalFeedback?.title as string}
        subTitle={modalFeedback?.subTitle as string}
        icon={modalFeedback?.icon as 'success' | 'error' | 'warning'}
        showButtonModal={modalFeedback?.showButtonModal}
        textButton={modalFeedback?.textButton as string}
        handleButtonModal={modalFeedback?.buttonAction}
      />
    </>
  )
}

export default MeuPsicoterapeuta;